import {decodeToken} from "../store/utils/jwt";

export const MINIMUM_VALIDITY_SECONDS = 10

export const checkValidSeconds = (token, seconds = MINIMUM_VALIDITY_SECONDS) => {
    if (typeof token !== 'string' || !token) {
        return false
    }
    try {
        const decoded = decodeToken(token)
        return (decoded.exp - seconds) * 1000 > new Date().getTime()
    } catch (err) {
        console.log(err)
        return false
    }
}
